import ExternalHTTPInstance, { ExternalHTTP } from "./datasources/ExternalHTTP"
import GrowthBookInstance from "./datasources/GrowthBook"

export { ExternalHTTP, ExternalHTTPInstance, GrowthBookInstance }
